module.exports = __webpack_public_path__ + "img/0-81.9bfd1157.jpg";